import { defineSlotRecipe } from '@chakra-ui/react';

export const formSectionSlotRecipe = defineSlotRecipe({
	className: 'form-section',
	base:      {
		column: {
			color:          'text',
			justifyContent: 'space-between',
			p:              6,
			textStyle:      'h4',
		},
		description: {
			borderBottom: '1px solid {colors.gray.15}',
			color:        'gray.100',
			px:           6,
			py:           4,
			textStyle:    'p5',
		},
		field: {
			color:     'text',
			p:         6,
			textStyle: 'p4',
		},
		footer: {
			borderTop: '1px solid {colors.gray.15}',
			display:   'flex',
			px:        6,
			py:        3,
		},
		root: {
			bg:           'white',
			borderRadius: 'lg',
			borderWidth:  '1px',
			overflow:     'hidden',
		},
		row: {
			'& > *:first-child':   { bg: 'gray.10' },
			'borderBottom':        '1px solid {colors.gray.15}',
			'display':             'grid',
			'gap':                 0,
			'gridTemplateColumns': '250px 1fr',
		},
		title: {
			alignItems:     'center',
			borderBottom:   '1px solid {colors.gray.15}',
			color:          'text',
			display:        'flex',
			flexDirection:  'row',
			justifyContent: 'space-between',
			px:             6,
			py:             4,
			textStyle:      'h3',
			w:              'full',
		},
	},
	slots: [
		'root',
		'description',
		'column',
		'field',
		'header',
		'title',
		'body',
		'row',
		'footer',
	],
});
